import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d1bc791"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1bc791')) {
      api.createRecord('5d1bc791', component.options)
    } else {
      api.reload('5d1bc791', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d1bc791", function () {
      api.rerender('5d1bc791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommended/components/icon-manage/index.vue"
export default component.exports